import jsQR from 'jsqr'
import { useRef, useEffect } from 'react'
import { getReceptionStatus } from '../../components/event/getReceptionStatus'
import { setReception } from '../../components/event/setReception'

interface QRCodeProps {
    cookieAccId: string;
    cookieRotaryCd: string;
    isCameraActive: boolean;
    setIsCameraActive: (boolean: boolean) => void;
    message: string;
    setMessage: (string: string) => void;
    errorMessage: string;
    setErrorMessage: (string: string) => void;
}

export function ReadQRCode(props: QRCodeProps) {
    const videoRef = useRef<HTMLVideoElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);

    const videoWidth = 0;
    const videoHeight = 0;
    
    const canvasWidth = 300;
    const canvasHeight = 300;

    useEffect(() => {
        const constraints = {
            video: {
                facingMode: 'environment',
                width: { ideal: canvasWidth },
                height: { ideal: canvasHeight },
            },
        };
        // デバイスのカメラにアクセスする
        navigator.mediaDevices
            .getUserMedia(constraints)
            .then((stream) => {
                // デバイスのカメラにアクセスすることに成功したら、video要素にストリームをセットする
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    videoRef.current.load();
                    scanQrCode();
                }
            })
            .catch((err) => {
                //カメラの起動が失敗したので、
                //カメラを非表示にし、エラーメッセージを表示させる
                props.setIsCameraActive(false);
                props.setErrorMessage("カメラの起動に失敗しました。");
            });
        const currentVideoRef = videoRef.current;
        // コンポーネントがアンマウントされたら、カメラのストリームを停止する
        return () => {
            if (currentVideoRef && currentVideoRef.srcObject) {
                const stream = currentVideoRef.srcObject as MediaStream
                const tracks = stream.getTracks()
                tracks.forEach((track) => track.stop())
            }
        }
    })

    //QRコードスキャン
    async function scanQrCode() {
        const canvas = canvasRef.current;
        const video = videoRef.current;
        if (canvas && video) {
            const ctx = canvas.getContext('2d', {
                willReadFrequently: true
            });
            if (ctx) {
                // カメラの映像をcanvasに描画する
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                // QRコードをスキャンする
                const qrCodeData = jsQR(imageData.data, imageData.width, imageData.height);
                if ((qrCodeData) && (qrCodeData.data)){
                    //APIを呼び出して、イベントが存在しているか確認
                    //現在はqrCodeDataにイベントコードをそのまま載せてる
                    const eventExists = await getReceptionStatus({
                        accountId: props.cookieAccId,
                        eventCode: qrCodeData.data,
                        rotaryCd: props.cookieRotaryCd
                    });
                    //存在しているかつ登録可能であれば登録
                    if (Object.keys(eventExists).length  !== 0) {
                        //受付済みイベントであれば受付済みの旨のエラーメッセージを設定
                        if (eventExists.receptionFlag) {
                            props.setErrorMessage("すでに受付済みのイベントです。");
                        } else {
                            //通常受付
                            await setReception({
                                loginId: props.cookieAccId,
                                eventJoinId: eventExists.eventJoinId,
                                rotaryCd: props.cookieRotaryCd
                            });
                            
                            //キャンセル待ち順番が1以上であればその旨のメッセージを設定
                            if (eventExists.cancelWaitingFlag){
                                props.setMessage("受付が完了しました。食事の提供に関しては受付にてご確認ください。");
                            } else{
                                //通常受付完了のメッセージを設定
                                props.setMessage("受付が完了しました。");
                            }
                        }
                    }
                    //読込み失敗の場合の汎用エラーメッセージを表示
                    else {
                        props.setErrorMessage("QRコードの読み込みに失敗しました。受付にてご確認ください。");
                    }
                    //スキャンが完了したらカメラを非表示
                    props.setIsCameraActive(false);
                    return
                }
                setTimeout(scanQrCode, 100);
            }
        }
    }

    return (
        <>
            <video ref={videoRef} width={`${videoWidth}`} height={`${videoHeight}`} autoPlay playsInline />
            <canvas className="qr" ref={canvasRef} width={`${canvasWidth}`} height={`${canvasHeight}`} />
        </>
    )
}